"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=7%3A320))
 * @lastsynced 2026-10-29T13:48:47.970Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const ArrowLeft = createSVGIcon(
  <path
    d="M23.143 12H.857m6 6-6-6 6-6"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "ArrowLeft",
  {
    viewBox: "0 0 24 24",
    color: iconColor.primary,
    fill: "none",
    className: iconCls(),
  }
);
